import { Injectable } from '@angular/core';
import { ErrorCodes } from '@shared';
import { LoggingService } from '@shared/logging';
import { QueryParamsProvider } from '../../routing/services/query-params.provider';

@Injectable()
export class SamplesTableProvider {
	private samplesTable: string;

	public constructor(
		private loggingService: LoggingService,
		private queryParamsProvider: QueryParamsProvider
	) {}

	public get getSamplesTable(): string {
		if (!this.samplesTable) {
			this.loggingService.error(ErrorCodes.NoSamplesTable, '');
			throw new Error(`No Samples table defined for entity ${this.queryParamsProvider.parentTableName}`);
		}

		return this.samplesTable;
	}

	public set samplesTableName(samplesTable: string) {
		this.samplesTable = samplesTable;
	}
}
